import React from "react";
import Style from '../../styles/components/layout/BoxShadow.module.css'


const BoxShadow = ({ children, style, className }) => {
  return <div className={`${Style.boxShadow} ${className}`} style={style}>{children}</div>;
};

export default BoxShadow;
